import request from '@/utils/request'

// 根据类型查询文章
export function teamList(query) {
  return request({
    url: '/web/menu/teamlist',
    method: 'get',
    params: query
  })
}

// 根据类型查询文章
export function honorsDutylist(query) {
    return request({
      url: '/web/menu/honorsDutylist',
      method: 'get',
      params: query
    })
  }